<template>
  <b-form-tags 
  duplicate-tag-text="Tag(s) duplicada(s)"
  invalid-tag-text="Tag(s) inválida(s)"
  placeholder="Adicione TAGs"
  remove-on-delete
  name="teste"
  :required="required"
  add-button-text="Adicionar"
  :value="value"
  :tag-validator="validator"
  @input="$emit('input', $event)"/>
</template>

<script>
export default {
  props: {
    required: {
      type: Boolean
    },
    value: {
      type: Array,
      required: true
    }
  },
  methods: {
    validator (tagWriting) {
      return tagWriting !== undefined
    }
  }
}
</script>

<style lang="scss">
.badge.badge-secondary {
  align-items: center;
  line-height: 1;
  background-color: black;
  padding: 0.25rem;
  font-weight: normal;
  button.close {
    font-size: 100%;
    vertical-align: middle;
    text-shadow: none;
    height: auto;
    color: white !important;
    opacity: 1 !important;
    &:hover {

    }
  }
}
</style>